import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.get";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { all, call } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { msaCreditStatById } from 'redux/saga/entities/bound';
import { MsaOfferProduct } from './MsaOfferProduct';
export var TrialProduct =
/*#__PURE__*/
function (_MsaOfferProduct) {
  _inherits(TrialProduct, _MsaOfferProduct);

  function TrialProduct() {
    _classCallCheck(this, TrialProduct);

    return _possibleConstructorReturn(this, _getPrototypeOf(TrialProduct).apply(this, arguments));
  }

  _createClass(TrialProduct, null, [{
    key: "loadCreditStat",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function loadCreditStat(client, msa) {
      return regeneratorRuntime.wrap(function loadCreditStat$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return call(fetchEntityIfNeeded, msaCreditStatById, [client, msa.id]);

            case 3:
              _context.next = 9;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              _context.next = 9;
              return call(logger.warn, "Failed to find credit stat for msa [".concat(msa.id, "]"), _context.t0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, loadCreditStat, null, [[0, 5]]);
    })
  }, {
    key: "loadPurchaseData",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function loadPurchaseData(client) {
      var _ref, msaOfferId, msaOffer, msa;

      return regeneratorRuntime.wrap(function loadPurchaseData$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(TrialProduct.getProductData);

            case 2:
              _ref = _context2.sent;
              msaOfferId = _ref.msaOfferId;
              _context2.next = 6;
              return call(TrialProduct.loadOffer, client, msaOfferId);

            case 6:
              msaOffer = _context2.sent;

              if (!msaOffer) {
                _context2.next = 11;
                break;
              }

              msa = msaOffer.msa;
              _context2.next = 11;
              return all([call(TrialProduct.loadCreditStat, client, msa), call(_get(_getPrototypeOf(TrialProduct), "loadPurchaseData", this), client)]);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, loadPurchaseData, this);
    })
  }]);

  return TrialProduct;
}(MsaOfferProduct);

_defineProperty(TrialProduct, "key", 'TrialProduct');